// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__TYIJU","wrap":"_styles_wrap__wdYVw","email":"_styles_email__Qadsw","view_all":"_styles_view_all__i81T1"};